routes.$inject = [ '$stateProvider', '$urlRouterProvider', '$locationProvider' ]
import GlobalConfig from '../../../../globals/globalConfig.json'
export default function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	$locationProvider.html5Mode(true)
	$stateProvider
		.state('generalSettings.users', {
			abstract    : false,
			url         : '/users',
			template    : require('./list/users.html'),
			controller  : 'UsersCtrl',
			controllerAs: 'usrVM',
			data        : {
				displayName: 'Usuarios',
				order      : 3,
				siblings   : [
					{
						name        : 'generalSettings.notificationsManagement',
						rolesAllowed: [ GlobalConfig.userRolesIds.generalAdmin, GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant ],
						order       : 1,
					},
					{
						name        : 'generalSettings.listParams',
						rolesAllowed: [ GlobalConfig.userRolesIds.generalAdmin, GlobalConfig.userRolesIds.workPlanAdmin ],
						order       : 2,
					},
					{
						name        : 'generalSettings.listSubject',
						rolesAllowed: [ GlobalConfig.userRolesIds.generalAdmin, GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant ],
						order       : 4,
					},
				],
			},
		})
		.state('generalSettings.createUsers', {
			abstract    : false,
			url         : '/createUsers/:roleId',
			template    : require('./create/createUsers.html'),
			controller  : 'CreateUsersCtrl',
			controllerAs: 'createUserVM',
			redirectTo  : 'generalSettings.users',
			data        : {
				displayName: 'Usuarios',
				order      : 3,
				siblings   : [
					{
						name        : 'generalSettings.notificationsManagement',
						rolesAllowed: [ GlobalConfig.userRolesIds.generalAdmin, GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant ],
						order       : 1,
					},
					{
						name        : 'generalSettings.listParams',
						rolesAllowed: [ GlobalConfig.userRolesIds.generalAdmin, GlobalConfig.userRolesIds.workPlanAdmin ],
						order       : 2,
					},
					{
						name        : 'generalSettings.listSubject',
						rolesAllowed: [ GlobalConfig.userRolesIds.generalAdmin, GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant ],
						order       : 4,
					},
				],
			},
		})
		.state('generalSettings.createCommittee', {
			abstract    : false,
			url         : '/createCommittee',
			template    : require('./create/createCommittee.html'),
			controller  : 'CreateCommitteeCtrl',
			controllerAs: 'createCommitteeVM',
			redirectTo  : 'generalSettings.users',
			data        : {
				displayName: 'Usuarios',
				order      : 3,
				siblings   : [
					{
						name        : 'generalSettings.notificationsManagement',
						rolesAllowed: [ GlobalConfig.userRolesIds.generalAdmin, GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant ],
						order       : 1,
					},
					{
						name        : 'generalSettings.listParams',
						rolesAllowed: [ GlobalConfig.userRolesIds.generalAdmin, GlobalConfig.userRolesIds.workPlanAdmin ],
						order       : 2,
					},
					{
						name        : 'generalSettings.listSubject',
						rolesAllowed: [ GlobalConfig.userRolesIds.generalAdmin, GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant ],
						order       : 4,
					},
				],
			},
		})
		.state('generalSettings.editCommittee', {
			abstract    : false,
			url         : '/editCommittee/:committeeId',
			template    : require('./edit/editCommittee.html'),
			controller  : 'EditCommitteeCtrl',
			controllerAs: 'editCommitteeVM',
			redirectTo  : 'generalSettings.users',
			data        : {
				displayName: 'Usuarios',
				order      : 3,
				siblings   : [
					{
						name        : 'generalSettings.notificationsManagement',
						rolesAllowed: [ GlobalConfig.userRolesIds.generalAdmin, GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant ],
						order       : 1,
					},
					{
						name        : 'generalSettings.listParams',
						rolesAllowed: [ GlobalConfig.userRolesIds.generalAdmin, GlobalConfig.userRolesIds.workPlanAdmin ],
						order       : 2,
					},
					{
						name        : 'generalSettings.listSubject',
						rolesAllowed: [ GlobalConfig.userRolesIds.generalAdmin, GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant ],
						order       : 4,
					},
				],
			},
		})
		.state('fullscreen.listCommittee', {
			abstract    : false,
			url         : '/listCommittee',
			template    : require('./userCommittee/teacherCommittee.html'),
			controller  : 'ListCommitteeCtrl',
			controllerAs: 'listCommVM',
			data        : {
				displayName: 'Listado comités por usuario',
			},
		})
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/users/users.route.js